"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tagline = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("../common/offer-styles.js");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _layout = require("../common/layout.js");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GreenWrapper = (0, _styledComponents["default"])(_offerStyles.WithIconWrapper).withConfig({
  displayName: "GreenWrapper",
  componentId: "sc-6k9mbj-0"
})(["&&{background-color:", ";border-radius:8px;padding:8px 16px;margin-bottom:16px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mermaidGreen100;
});
var Tagline = (0, _styledComponents.withTheme)(function (_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.FlexRow, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(GreenWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "feedback/thumbs-up",
        color: theme.mermaidGreen500
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        children: children
      })]
    })
  });
});
exports.Tagline = Tagline;
//# sourceMappingURL=tagline.js.map